require('./utils/bootstrap');
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import YDUI from 'vue-ydui'
import VueLazyload from 'vue-lazyload'
import FastClick from 'fastclick'     //解决点击事件延迟问题
import {ProgressBar} from 'vue-ydui/dist/lib.rem/progressbar';//vue组件进度条
import 'vue-ydui/dist/ydui.rem.css'
import 'vue-ydui/dist/ydui.base.css';
import './utils/register'
import api from './utils/api/index'    //接口
import appMethod from './utils/app/unit'   //app原生方法
import {VeeValidate, Veeconfig} from './utils/validation.js';   //验证规则
import session from './utils/storage/session.js';
import local from './utils/storage/local.js';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import vueg from 'vueg'
import 'vueg/css/transition-min.css'
import 'swiper/dist/css/swiper.css' //引入swiper滑块样式
import { RadioGroup, Radio, Uploader, Stepper, Toast, Swipe, SwipeItem, ImagePreview, Icon, Tab, Tabs, Picker,Dialog } from 'vant';
import { Popup, IndexList, IndexSection } from 'mint-ui'
import 'mint-ui/lib/style.css'
import Tabbar from '@/components/common/Tabbar.vue'
import noData from "@/components/common/noData"
import skyCountdown from "@/components/countdown/countdownd"
import downloadTip from '@/components/download/download.vue'
import PullTo from '@/components/pull/src/index.js'
import layer from 'sky-layer'
import VConsole from 'vconsole'

//import es6 from '@/components/es6-promise.auto.min.js'
//window.FETCHER_SERVER_URL = "ws://fetcher.mudu.tv:8088";
//window.FETCHER_SERVER_URL = "wss://fetcher.mudu.tv";
//import bundle from '@/components/bundle.6d7aca164d2389e8bea6.js'


//import sdk from '@/components/sdk.js'
//import bundle from './assets/bundle.6d7aca164d2389e8bea6.js'
//import sdk from './assets/sdk.js'

//后面加的
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css' // 引入样式
import 'vue-video-player/src/custom-theme.css' // 引入样式
import 'videojs-flash'
// import 'video.js/dist/lang/zh-CN.js'
Vue.use(VueVideoPlayer)

// 动态修改页面title
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

//Vue.use(es6);
//window.FETCHER_SERVER_URL = "ws://fetcher.mudu.tv:8088";
//Vue.use(bundle);
//Vue.use(sdk);

import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)
import VueStickto from 'vue-stickto'
Vue.use(VueStickto);
Vue.component('PullTo',PullTo);
Vue.component('Tabbar',Tabbar);
Vue.component('noData',noData);
Vue.component('skyCountdown',skyCountdown);
Vue.component('downloadTip',downloadTip);
Vue.component(Popup.name, Popup);
Vue.component(IndexList.name, IndexList);
Vue.component(IndexSection.name, IndexSection);
Vue.component(ProgressBar.name, ProgressBar);
Vue.use(VueAwesomeSwiper);
Vue.use(VeeValidate,Veeconfig);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Uploader);
Vue.use(Stepper);
Vue.use(Swipe).use(SwipeItem);
Vue.use(Tab).use(Tabs);
Vue.use(Icon);
Vue.use(Picker);
Vue.use(Dialog);
Vue.prototype.$toast = Toast;
Vue.prototype.$ImagePreview = ImagePreview;

// this.$layer.alert('确认删除吗？',{title:'',btn:'知道了'},()=>{alert()})
//this.$layer.closeAll();
//按需引入使用
Vue.prototype.$layer = layer(Vue);
import gallery from 'img-vuer'
Vue.use(gallery)
import './styles/common.less'
import './styles/init.less'
Vue.config.productionTip = false

//延迟点击
FastClick.attach(document.body)

Vue.prototype.$session = session;
Vue.prototype.$local = local;

//接口
Vue.prototype.api = api;
Vue.prototype.appMethod = appMethod;


Vue.use(YDUI)

Vue.use(VueLazyload)
const options={
  duration: '.3',
  firstEntryDisable: true,
  firstEntryDuration: '.1',
  forwardAnim: 'fadeIn',
  backAnim: 'fadeIn',
  sameDepthDisable: false,
  tabs: [],
  tabsDisable: true,
  shadow:false,
  disable: false,
  nuxt: false
}
Vue.use(vueg, router,options)

if(window.location.host.indexOf('wap-pre') >= 0 ||window.location.host.indexOf('test.wap') >= 0 || window.location.host.indexOf(':8089') >= 0){
  const vConsole = new VConsole();
}

// 导航守卫
router.beforeEach((to, from, next) => {
	//微信分享路径处理
	var str = window.location.href;
    if (str.indexOf('?from')!='-1') {
    	let newUrl = str.split('/?from')[0]+ '#' + str.split('#')[1]
    	window.location.assign(newUrl)
    }
    if(to.query.platform === 'app'){
        local.set('client', 0);     //client    时刻会变的，页面之间切换都会监听到改变
        local.set('appOs',1)		//appOs     只要从app进入过，就一直保持在1    用于判断入口只要是app的情况
      }else {
        local.set('client', 1);
      }
      //给app传参数
      let post = {
        title : to.meta.title,
        isShare: to.meta.isShare ? to.meta.isShare : false,
        isShareImg: to.meta.isShareImg ? to.meta.isShareImg : false,
        shareImg: to.meta.shareImg ? to.meta.shareImg : false,
        mark : '3.0',
        rightBtn:to.meta.rightBtn ? to.meta.rightBtn : false,
        rightBtnText:to.meta.rightBtnText,
        jsMethod:to.meta.jsMethod,
        hideTitle:to.meta.hideTitle
      };
      try{
        window.webkit.setTitle(JSON.stringify(post));
      }catch(e){
      }
      try{
        window.webkit.messageHandlers.setTitle.postMessage(JSON.stringify(post));
      }catch(e){
      }
    if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
        if (Cookie.get('keyCode')) {  // 获取当前的token是否存在
            next();
        }else {
            next({
                path: '/login',
                query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        }
    }
    else {
    	next();
    }
})

router.afterEach((to, form) => {

})

let vm =  new Vue({
  el: '#app',
  router,
  store,
  components: { App},
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js